import { useEffect, useState } from "react";
import CookieConsent from "react-cookie-consent";
import { Link } from "@/lib/router-compat";
import {
  CONSENT_COOKIE,
  CONSENT_DAYS,
  OPEN_CONSENT_EVENT,
  announceConsent,
  clearConsent,
  readConsent,
} from "@/lib/consent";

// Both buttons get the same size, weight and shape: the visitor is not nudged either way.
const buttonStyle: React.CSSProperties = {
  background: "hsl(var(--card))",
  color: "hsl(var(--foreground))",
  border: "1px solid hsl(var(--primary))",
  fontSize: "14px",
  fontWeight: 600,
  borderRadius: "6px",
  padding: "10px 24px",
  margin: "0 8px 8px 0",
};

/**
 * Cookie banner, mounted once in the root layout so it appears on every page.
 * Google Tag Manager and Analytics are loaded elsewhere and only after "Akzeptieren".
 */
export const GDPRCookieConsent = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (readConsent() === null) setOpen(true);
    const reopen = () => {
      clearConsent();
      setOpen(true);
    };
    window.addEventListener(OPEN_CONSENT_EVENT, reopen);
    return () => window.removeEventListener(OPEN_CONSENT_EVENT, reopen);
  }, []);

  if (!open) return null;

  return (
    <CookieConsent
      visible="show"
      location="bottom"
      cookieName={CONSENT_COOKIE}
      expires={CONSENT_DAYS}
      sameSite="lax"
      enableDeclineButton
      buttonText="Akzeptieren"
      declineButtonText="Ablehnen"
      ariaAcceptLabel="Statistik-Cookies akzeptieren"
      ariaDeclineLabel="Statistik-Cookies ablehnen"
      customContainerAttributes={{ role: "region", "aria-label": "Cookie-Hinweis" }}
      style={{
        background: "hsl(var(--card))",
        color: "hsl(var(--foreground))",
        borderTop: "1px solid hsl(var(--border))",
        padding: "16px 20px",
        alignItems: "center",
        zIndex: 60,
      }}
      contentStyle={{ flex: "1 1 320px", margin: "0 16px 8px 0", fontSize: "14px", lineHeight: 1.5 }}
      buttonStyle={buttonStyle}
      declineButtonStyle={buttonStyle}
      onAccept={() => {
        setOpen(false);
        announceConsent("true");
      }}
      onDecline={() => {
        setOpen(false);
        announceConsent("false");
      }}
    >
      Wir verwenden Cookies nur mit Ihrer Zustimmung. Statistik-Cookies (Google Analytics) helfen
      uns, die Website zu verbessern. Details in unserer{" "}
      <Link to="/datenschutz" className="underline hover:text-primary">
        Datenschutzerklärung
      </Link>
      .
    </CookieConsent>
  );
};
